document.addEventListener('variant:changed', () => {
    let gallery = document.querySelector('.product__media-list--grid-img')
    if(!gallery) return
    let cloneDescription = gallery.querySelector('.image-with-text__text-item')

    if(!cloneDescription) {
        let description = document.querySelector('.image-with-text__text-item')
        if(!description) return

        cloneDescription = description.cloneNode(true)
        //cloneDescription.classList.add('product__media-item', 'grid__item', 'slider__slide')
        cloneDescription.style.paddingBottom = "0"

        gallery.appendChild(cloneDescription)
    }

    let section = document.querySelector('.image-with-text')

    if(isEven()) {
        cloneDescription.style.display = 'none'
        section.style.display = 'unset'
    }else {
        if(screen.width > 769) {
            cloneDescription.style.display = 'unset'
            section.style.display = 'none'
        } else {
            cloneDescription.style.display = 'none'
        }
    }
})

const isEven = () => {
    let imgs = [...document.querySelector('.product__media-list--grid-img').children]
    if(!!!imgs.length) return false

    let imgsNotHidden = imgs.filter(img => !img.classList.contains('hidden') && !img.classList.contains('image-with-text__text-item'))

    return (imgsNotHidden.length%2) == 0
}
